import axios from 'axios'

const axiosInstance = axios.create({
  timeout: 10000,
  withCredentials: true,
  maxBodyLength: Infinity,
})

axiosInstance.interceptors.request.use(
  (config) => {
    if (
      ['get', 'post', 'put', 'delete', 'patch'].includes(
        config.method?.toLowerCase() || '',
      )
    ) {
      const csrfToken = localStorage.getItem('csrftoken')

      if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken

      } else {
        console.warn(`⚠️ No CSRF token available for ${config.method?.toUpperCase()} ${config.url}`);
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/login'
    }
    return Promise.reject(error)
  },
)

export default axiosInstance
